<template>
  <Popup
    v-model="popupShow"
    position="bottom"
    radius="5px"
    class="select-product-popup"
    @close="onCancel"
  >
    <div class="popup-bar">
      <div class="cancel" @click="onCancel">取消</div>
      <div class="title">选择分组</div>
      <div class="ok" @click="onOk">确定</div>
    </div>
    <div class="content">
      <Search v-model="searchInput" placeholder="搜索" />
      <List
        style="height: 100%;margin-top:-5px;padding: 5px 12px"
        :offset="50"
        :immediate-check="true"
      >
        <div
          v-for="(item, index) in group"
          :key="index"
          @click="onSelect(item)"
          :class="{
            'product-item': true,
            selected: selected.id == item.id,
            'flex-center-y': true,
          }"
        >
          <div class="title-small">{{ item.groupName }}</div>
        </div>
      </List>
    </div>
  </Popup>
</template>

<script>
import { List, Popup, Sticky, Search } from "vant";
import { downloadImg } from "@/config";

export default {
  components: {
    Popup,
    List,
    Sticky,
    Search,
  },
  props: {
    show: { type: Boolean, default: false },
    group: { type: Array, required: true },
    showAll: { type: Boolean, default: false },
    // defaultTitle: {type: String, default: '请选择产品'},
  },
  data() {
    return {
      selected: {},
      searchInput: ``,
      groupList: [],
    };
  },
  watch: {
    searchInput(newValue) {
      if (this.groupList.length === 0) {
        this.groupList = this.group;
        this.group = this.group.filter((item) => {
          return (
            item.groupName.toLowerCase().indexOf(newValue.toLowerCase()) >= 0
          );
        });
      } else {
        this.group = this.groupList.filter((item) => {
          return (
            item.groupName.toLowerCase().indexOf(newValue.toLowerCase()) >= 0
          );
        });
      }
    },
  },
  computed: {
    popupShow: {
      get() {
        return this.show;
      },
      set() {
        this.onCancel();
      },
    },
    // title() {
    //     return (this.selected||{}).productName || this.defaultTitle
    // },
  },
  methods: {
    onCancel() {
      this.$emit("cancel");
    },
    onOk() {
      this.$emit("ok", this.selected);
    },
    getImgUrl(url) {
      return downloadImg + url;
    },
    onSelect(product) {
      if (product) {
        this.selected = product;
        setTimeout(this.onOk, 120);
      } else {
        setTimeout(this.onCancel, 120);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.select-product-popup {
  height: calc(100% - 140px);
  display: flex;
  flex-direction: column;

  & > .content {
    display: flex;
    flex-direction: column;
    height: calc(100% - 50px);
    overflow-y: auto;
  }
}

.product-item {
  &.selected {
    border-bottom: 1px solid rgba(24, 144, 255, 1);
    background-color: rgba(24, 144, 255, 1);
    padding: 12px;
  }
  padding: 5px;
  display: flex;
  border-bottom: 1px solid rgba(111, 111, 111, 0.3);
  padding: 12px;
  & > img {
    height: 50px;
    width: 50px;
    margin: 5px;
  }
  & > .right {
    margin-left: 8px;
    line-height: 2.5;
  }
}
</style>
